import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStaffUpdateSalaryDetailList, getStaffUpdateSalaryDetailType } from '@/api/payroll';
export default {
  components: {},
  props: {
    staffId: String,
    subProjectId: String,
    type: String
  },
  data: function data() {
    return {
      historyList: [],
      columnsList: [],
      salaryData: {},
      sysInfo: {
        settlement_type: []
      },
      staff_id: this.$route.params.staff_id,
      settlement_type: '',
      year: new Date().getFullYear().toString()
    };
  },
  created: function created() {
    this.getSysInfoFn();
  },
  methods: {
    getSysInfoFn: function getSysInfoFn() {
      var _this = this;
      // 员工调薪详情_type
      getStaffUpdateSalaryDetailType({
        staff_info_id: this.staff_id,
        year: this.year
      }).then(function (res) {
        if (res && res.code === 1) {
          _this.sysInfo.settlement_type = res.data;
          _this.settlement_type = res.data.length ? res.data[0].settlement_type : _this.$route.query.type;
        }
        _this.init();
      });
    },
    handlerBack: function handlerBack() {
      this.$router.go(-1);
    },
    handleData: function handleData(val) {
      if (typeof val === 'string') {
        return val.indexOf('http') !== -1;
      }
    },
    init: function init() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getStaffUpdateSalaryDetailList({
                staff_info_id: _this2.staff_id,
                settlement_type: _this2.settlement_type,
                year: _this2.year
              });
            case 2:
              res = _context.sent;
              _context.prev = 3;
              if (!(res && res.code === 1)) {
                _context.next = 12;
                break;
              }
              _this2.salaryData = res.data.staff_info;
              _this2.columnsList = [];
              _this2.historyList = [];
              if (res.data.columns.length) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return");
            case 10:
              res.data.columns.forEach(function (item) {
                var val = res.data.column_datetime[item];
                _this2.columnsList.push({
                  label: "".concat(val.date, " ").concat(val.time),
                  prop: item
                });
              });
              _this2.historyList = res.data.item_val;
            case 12:
              _context.next = 16;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 14]]);
      }))();
    },
    handleYear: function handleYear() {
      this.init();
    },
    onClick: function onClick(url) {
      window.open(url);
    }
  }
};